import IntegrationKeys from 'components/pages/settings/integration-keys'

export default IntegrationKeys
